import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['reloadIcon']

  reload () {
    this.reloadIconTarget.classList.add('animate-spin')
    window.location.reload()
  }
}
